import { render, staticRenderFns } from "./CourseBuilderVideoQuizForm.vue?vue&type=template&id=f7ccdcfc&scoped=true&"
import script from "./CourseBuilderVideoQuizForm.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderVideoQuizForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseBuilderVideoQuizForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CourseBuilderVideoQuizForm.vue?vue&type=style&index=1&id=f7ccdcfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ccdcfc",
  null
  
)

export default component.exports